export default __webpack_public_path__ + "static/media/logout.229dfc12.svg";